import React, { useState } from 'react'
import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { CardFlexEl, El, FlexEl } from '../layout'
import { func, string } from 'prop-types'
import { CarlinPropTypes } from '../../entities'
import util from '../../util'
import { ReactComponent as Airport } from '../../util/images/icon-airport.svg'
import { ReactComponent as Location } from '../../util/images/icon-location.svg'
import { ReactComponent as Automatic } from '../../util/images/icon-automatic.svg'
import { ReactComponent as Manuel } from '../../util/images/icon-manual.svg'
import { ReactComponent as Seat } from '../../util/images/icon-seat.svg'
import { ReactComponent as Insurance } from '../../util/images/icon-insurance.svg'
import VerticalDash from '../../util/images/pickup-dropoff-line@3x.webp'
import { ReactComponent as InfoIcon } from '../../util/images/material-symbols-info.svg'

export const Info = styled(({ icon, description, ...props }) => (
  <FlexEl {...props}>
    <El className='icon'>{icon}</El>
    <El className='description'>{description}</El>
  </FlexEl>
))`
  ${props => props.chip && `
      background-color: rgb(236 239 255);
      border-radius: 1rem; 
      margin-bottom: 4px;
      & .description {
        color: #2563eb !important;
        font-weight: 600 !important;
        padding-inline: 12px;
        padding-block: 2px !important;
      }
    `} 
  .icon {
    margin-right: 3px;
    @media (min-width: ${themeGet('breakpoints.0')}px) {
      margin-right: 3px;
    }
  }
  .description {
    color: ${themeGet('colors.textBlack')};
    /* font-size: 15px; */
    font-weight: normal;
    padding-bottom: 4px;
    margin-top: auto;
    margin-bottom: auto;
    @media (min-width: ${themeGet('breakpoints.0')}px) {
      font-size: 14px;
    }
  }
`

export const BookButton = styled(Info)`
  margin-left: auto;
  margin-right: auto;
  margin-top: 8px;
  .description {
    color: white;
    font-size: 16px;
    font-weight: bold;
    padding: 0;
  }
`

const icon = '🚀'

const Highlight = styled(({ text, ...props }) => (
  <FlexEl {...props}>
    <div className='h-icon'>{`${icon}`}</div>
    <El>{text}</El>
  </FlexEl>
))`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: auto;
  margin-left: auto;
  padding: 5px;
  color: #fa5b94;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: 2px solid #fa5b94;
  border-radius: 0px 8px 0px 8px;
  background-color: #fff2f4;
  text-align: center;
  > .h-icon {
    margin: 0px 8px;
  }

  @media (min-width: ${themeGet('breakpoints.0')}px) {
    position: absolute;
    top: -1px;
    right: -1px;
  }
`

Highlight.propTypes = {
  text: string
}

const OuterContainer = styled(CardFlexEl)`
  max-width: 784px;
  flex-direction: column;
  font-family: 'Quicksand', 'Quicksand Regular', sans-serif;
  color: #525266;
  padding: 0;

  @media (max-width: ${themeGet('breakpoints.0')}px) {
    width: 90vw;

    > .book-button {
      width: 50%;
      font-size: 18px !important;
      border: none;
      outline: none;
    }
  }

  .book-button {
    background-image: radial-gradient(circle at 2% 54%, #fe9661, #ff7d0e 47%, #ffb369 90%);
    min-width: 175px;
    margin-top: auto;
    margin-left: auto;
    margin-right: 16px;
    margin-bottom: 16px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    border-radius: 8px;
    min-height: 44px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    border: none;
    outline: none;
  }

  @media (min-width: ${themeGet('breakpoints.0')}px) {
    padding: 0;
  }
`

const InnerContainer = styled(FlexEl)`
  display: flex;
  align-items: center;
  margin: 0;

  @media (max-width: ${themeGet('breakpoints.0')}px) {
    flex-direction: column;
  }
  @media (min-width: ${themeGet('breakpoints.0')}px) {
    flex-direction: row;
    padding: 0;
    position: relative;
  }
`

const ImageContainer = styled(FlexEl)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: none;
  width: 30%;
  padding: 5px;
  overflow: hidden;

  img {
    margin: 5px;
    align-items: center;
    object-fit: contain;
  }

  .supplier-img {
    max-width: 50%;
    max-height: 40px;
  }

  .highlight-mobile {
    display: none;
  }

  .car-img {
    max-height: 90px;
    min-height: 90px;
  }

  @media (max-width: ${themeGet('breakpoints.0')}px) {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    padding: 0px;

    .supplier-img {
      grid-row-start: 1;
      grid-column-start: 1;
    }

    .highlight-mobile {
      display: flex;
    }

    .car-img {
      grid-column: span 2;
      justify-self: center;
      grid-row-start: 2;
    }
  }
`

const InfoFirst = styled(FlexEl)`
  flex-direction: column;
  justify-content: center;
  align-self: flex-end;
  width: 45%;
  padding: 10px;
  align-items: flex-start;
  margin-left: 0%;
  margin-top: 2%;

  > :not(.station-container) {
    margin: 0px 5px;
  }

  .car-group-description {
    font-size: 20px;
    font-weight: 600;
    color: #ff7d0e;
  }

  .car-name {
    color: #525266;
    font-size: 14px;
    font-weight: 500;
  }

  .station-container {
    flex-direction: column;
    margin-top: 5%;

    .left-frame-tablet {
      @media (min-width: ${themeGet('breakpoints.1')}px) {
        display: none;
      }

      @media (max-width: ${themeGet('breakpoints.1')}px) {
        display: flex;
        margin-top: 10px;
        > * {
          margin: 0px 2.5px;
        }
      }
      @media (max-width: ${themeGet('breakpoints.0')}px) {
        display: none;
      }
    }
  }

  @media (max-width: ${themeGet('breakpoints.0')}px) {
    margin: 0px 5px;
    width: 100%;
    align-self: center;
  }
`

const InfoSecond = styled(FlexEl)`
  flex-direction: column;
  width: 25%;
  align-self: flex-end;
  margin: 32px 16px 16px;

  @media (max-width: ${themeGet('breakpoints.0')}px) {
    width: 100%;
    margin-top: 10px;
  }

  .inner-container {
    flex-direction: row;

    @media (min-width: ${themeGet('breakpoints.1')}px) {
      justify-content: flex-end;
    }

    @media (max-width: ${themeGet('breakpoints.1')}px) {
      justify-content: flex-end;
    }

    @media (max-width: ${themeGet('breakpoints.0')}px) {
      justify-content: flex-end;
    }

    .left-frame-desktop {
      flex-direction: column;
      padding: 10px;
      align-self: flex-end;

      @media (min-width: ${themeGet('breakpoints.1')}px) {
        display: flex;
      }
      @media (max-width: ${themeGet('breakpoints.1')}px) {
        display: none;
      }
      @media (max-width: ${themeGet('breakpoints.0')}px) {
        display: flex;
      }
    }

    .right-frame {
      flex-direction: column;
      align-self: flex-end;

      .total-price {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
      @media (max-width: ${themeGet('breakpoints.0')}px) {
        .highlight-desktop {
          display: none !important;
        }
      }
    }
  }
`

const TotalAmountWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  gap: 10px;
`

const PriceTextHead = styled.div`
  font-family: 'Quicksand', 'Quicksand Regular', sans-serif;
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ff7d0e;
  text-align: right;
`

const DefaultOverlay = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
`

const AmountText = styled.div`
  font-family: Montserrat;
  font-size: 25px;
  font-weight: 520;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
`

const OldAmountText = styled.div`
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 420;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-decoration-line: line-through;
  color: #b4b4c2;
  text-align: right;
`

const DiscountText = styled.div`
  font-family: Montserrat;
  font-size: 25px;
  font-weight: 520;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #009750;
  text-align: right;
`

const LocationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  position: relative;
  max-width: 60vw;

  &::before {
    content: '';
    top: 17px;
    left: 8.5px;
    width: 2px;
    height: 50%;
    position: absolute;
    background: url(${VerticalDash});
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 0;
  }
`

const InfoColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`

const InclusionsInfo = styled(FlexEl)`
  align-items: center;
  padding-bottom: 4px;
  cursor: pointer;

  .inclusions-icon {
    display: flex;
    margin-right: 3px;
    svg {
      width: 16px;
      height: 16px;
    }
  }

  .inclusions-label {
    color: ${themeGet('colors.textBlack')};
    font-weight: normal;
    @media (min-width: ${themeGet('breakpoints.0')}px) {
      font-size: 14px;
    }
  }

  &:hover .inclusions-label {
    text-decoration: underline;
  }

  &.locked .inclusions-label {
    color: #0076ff;
    font-weight: 600;
    text-decoration: none;
  }

  .inclusions-popover {
    display: none;
    position: absolute;
    top: 50%;
    left: calc(100% + 16px);
    transform: translateY(-50%);
    width: 220px;
    padding: 12px 28px 12px 16px;
    background-color: white;
    border-radius: 12px;
    border: solid 1px var(--borderGrey);
    box-shadow: 0 0 6px 2px rgba(111, 112, 115, 0.2);
    z-index: 10;
    cursor: default;

    ul {
      margin: 0;
      padding-left: 18px;
    }
    li {
      font-size: 13px;
      color: #525266;
      padding: 2px 0;
    }
  }

  .inclusions-close {
    position: absolute;
    top: 6px;
    right: 8px;
    padding: 0;
    border: none;
    background: none;
    font-size: 18px;
    line-height: 1;
    color: #b4b4c2;
    cursor: pointer;
  }

  &:hover .inclusions-popover,
  &.locked .inclusions-popover {
    display: block;
  }

  @media (max-width: 1599px) {
    position: relative;
    .inclusions-popover {
      top: calc(100% + 8px);
      left: 0;
      transform: none;
    }
  }
`

const CarCard = ({ carRentalProduct, howManyDays, onBook, ...props }) => {
  const [inclusionsLocked, setInclusionsLocked] = useState(false)
  const { car, supplier, stationPair, extras, prices } = carRentalProduct

  const priceWithCommission = prices?.priceWithCommission
  const priceWithAdjustedCommission = prices?.priceWithAdjustedCommission

  return (
    <OuterContainer {...props}>
      <InnerContainer {...props}>
        <ImageContainer className='img-container'>
          <img className='supplier-img' src={util.toHttps(supplier.logoUrl)} alt={supplier.name} />
          {extras.highlight && <Highlight className='highlight-mobile' text={extras.highlight} />}
          <img className='car-img' src={util.toHttps(car.imageUrl)} alt={car.name} />
        </ImageContainer>
        <InfoFirst>
          <FlexEl className='car-group-description'>{car.groupDescription}</FlexEl>
          <FlexEl className='car-name'>{car.name}</FlexEl>
          <FlexEl className='station-container'>
            <LocationWrapper style={{ display: !stationPair.pickup.airport ? 'flex' : 'none' }}>
              <FlexEl className='pickup-container'>
                <Info
                  icon={stationPair.pickup.airport ? <Airport /> : <Location />}
                  description={util.failSafeLocation(stationPair.pickup)}
                />
              </FlexEl>
              <FlexEl className='drop-off-container'>
                <Info
                  icon={stationPair.dropOff.airport ? <Airport /> : <Location />}
                  description={util.failSafeLocation(stationPair.dropOff)}
                />
              </FlexEl>
            </LocationWrapper>
            <InfoColumnWrapper>
              <Info
                icon={car.transmissionDescription === 'Manual' ? <Manuel /> : <Automatic />}
                description={car.transmissionDescription}
              />
              <Info icon={<Seat />} description={`${car.seatCount} Seats`} />
              {carRentalProduct.extras.insured && <Info icon={<Insurance />} description={'Insurance'} />}
              <Info description={`Broker: ${carRentalProduct.dependencies.brokerName}`} />
              {carRentalProduct.onRequestConfirmation && <Info chip description="On Request" />}
              {carRentalProduct.inclusions && carRentalProduct.inclusions.length > 0 && (
                <InclusionsInfo
                  className={inclusionsLocked ? 'locked' : ''}
                  onClick={() => setInclusionsLocked((v) => !v)}
                >
                  <El className='inclusions-icon'>
                    <InfoIcon />
                  </El>
                  <El className='inclusions-label'>Inclusions</El>
                  <El className='inclusions-popover' onClick={(e) => e.stopPropagation()}>
                    <button className='inclusions-close' aria-label='Close' onClick={() => setInclusionsLocked(false)}>
                      ×
                    </button>
                    <ul>
                      {carRentalProduct.inclusions.map((inclusion, i) => (
                        <li key={i}>{inclusion}</li>
                      ))}
                    </ul>
                  </El>
                </InclusionsInfo>
              )}
            </InfoColumnWrapper>
          </FlexEl>
        </InfoFirst>
        <InfoSecond>
          {priceWithAdjustedCommission && (
            <TotalAmountWrapper>
              <DefaultOverlay>
                <PriceTextHead>What If Price</PriceTextHead>
                <AmountText>
                  {util.formatMoneyFloored(
                    priceWithAdjustedCommission.actualTotal,
                    priceWithAdjustedCommission.currency
                  )}
                </AmountText>
              </DefaultOverlay>
            </TotalAmountWrapper>
          )}
          {priceWithCommission && (
            <TotalAmountWrapper>
              <DefaultOverlay>
                <PriceTextHead>Carlin Price</PriceTextHead>
                <AmountText>
                  {util.formatMoneyFloored(priceWithCommission.actualTotal, priceWithCommission.currency)}
                </AmountText>
              </DefaultOverlay>
            </TotalAmountWrapper>
          )}
          <FlexEl className='inner-container'>
            <FlexEl className='right-frame'>
              {extras.highlight && <Highlight className='highlight-desktop' text={extras.highlight} />}
              <El className='total-price'>
                <TotalAmountWrapper>
                  {carRentalProduct.price.discountedTotal ? (
                    <div>
                      <>
                        <PriceTextHead>Total Price</PriceTextHead>
                        <DiscountText>
                          {util.formatMoneyFloored(
                            carRentalProduct.price.discountedTotal,
                            carRentalProduct.price.currency
                          )}
                        </DiscountText>
                      </>
                      <OldAmountText>
                        {util.formatMoneyFloored(carRentalProduct.price.total, carRentalProduct.price.currency)}
                      </OldAmountText>
                    </div>
                  ) : (
                    <DefaultOverlay>
                      <PriceTextHead>Partner Price</PriceTextHead>
                      <AmountText>
                        {util.formatMoneyFloored(carRentalProduct.price.actualTotal, carRentalProduct.price.currency)}
                      </AmountText>
                    </DefaultOverlay>
                  )}
                </TotalAmountWrapper>
              </El>
            </FlexEl>
          </FlexEl>
        </InfoSecond>
      </InnerContainer>
      {onBook && (
        <button className={'book-button'} onClick={() => onBook(carRentalProduct)}>
          Book now
        </button>
      )}
    </OuterContainer>
  )
}

CarCard.propTypes = {
  carRentalProduct: CarlinPropTypes.CarRentalProduct.isRequired,
  onBook: func.isRequired
}

export default CarCard
